import type { OverlayTemplate } from 'klinecharts';

const eightWaves: OverlayTemplate = {
  name: 'eightWaves',
  totalStep: 10,
  needDefaultPointFigure: true,
  needDefaultXAxisFigure: true,
  needDefaultYAxisFigure: true,
  createPointFigures: ({ coordinates }) => {
    const texts = coordinates.map((coordinate, i) => ({ ...coordinate, text: `(${i})`, baseline: 'bottom' }));
    return [
      { type: 'line', attrs: { coordinates } },
      { type: 'text', ignoreEvent: true, attrs: texts },
    ];
  },
};

export default eightWaves;
